import React from "react";
import { RiCloseFill } from "react-icons/ri";

const BackButton = () => {
  return (
    <div className="back-button">
      <span className="back x">
        {" "}
        <RiCloseFill />
      </span>
    </div>
  );
};

export default BackButton;
